// extracted by mini-css-extract-plugin
export default {"signingOrderAlert":"IKzmJXvSKjL4NkyY7ech"};